import React, { useState, useEffect } from 'react';
import {
    Box,
    TextField,
    Autocomplete,
    Paper,
    Typography,
    Button,
    Chip,
    Divider
} from '@mui/material';
import {
    Search as SearchIcon,
    LocationOn as LocationIcon,
    FileDownload as ExportIcon,
    Clear as ClearIcon
} from '@mui/icons-material';
import axios from 'axios';

export const CompetitorSearchBar = ({ locationsearch, exportValues, customBoundary }) => {
    const [region, setRegion] = useState('');
    const [filterList, setFilterList] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [regionsearchvalue, setRegionsearchvalue] = useState('');

    const inputSearch = async (searchValue) => {
        if (!searchValue) {
            setFilterList([]);
            return;
        }
        
        try {
            const token = localStorage.getItem("auth-token");
            const response = await axios.post('/gettheurl/competitorregion', 
                { region: searchValue.trim() }, 
                { headers: { "auth-token": token } }
            );
            const res = response.data;
            setFilterList(res.countysearch || []);
        } catch (error) {
            console.error('Error fetching regions:', error);
            setFilterList([]);
        }
    };

    const regions = (region) => {
        if (region.State) return `${region.Name} ${region.Region}, ${region.State}`;
        return region.Name;
    };

    const regionSelect = (selectedRegion) => {
        if (selectedRegion) {
            const regionText = regions(selectedRegion);
            setRegion(regionText);
            setRegionsearchvalue(regionText);
            setSelectedRegion(selectedRegion);
            locationsearch(selectedRegion);
        }
    };

    const clearSelection = () => {
        setRegion('');
        setRegionsearchvalue('');
        setSelectedRegion(null);
        setFilterList([]);
        locationsearch();
    };

    useEffect(() => {
        if (customBoundary) {
            setRegionsearchvalue('Custom Boundary');
        }
    }, [customBoundary]);

    return (
        <Box className="p-25-15-3">

                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                    {/* Region Search */}
                    <Autocomplete
                        freeSolo
                        options={filterList}
                        getOptionLabel={(option) => typeof option === 'string' ? option : regions(option)}
                        value={selectedRegion}
                        inputValue={region}
                        onInputChange={(event, newInputValue) => {
                            setRegion(newInputValue);
                            inputSearch(newInputValue);
                        }}
                        onChange={(event, newValue) => {
                            if (typeof newValue === 'string') {
                                // Handle free solo input
                                setRegion(newValue);
                            } else {
                                // Handle selection from dropdown
                                regionSelect(newValue);
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Filter by Location"
                                placeholder="Search region or state"
                                variant="outlined"
                                size="small"
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: <LocationIcon color="action" sx={{ mr: 1 }} />,
                                }}
                            />
                        )}
                        renderOption={(props, option) => (
                            <Box component="li" {...props}>
                                <LocationIcon sx={{ mr: 1, color: 'text.secondary' }} />
                                <Typography variant="body2">
                                    {regions(option)}
                                </Typography>
                            </Box>
                        )}
                        sx={{ minWidth: 280, flexGrow: 1 }}
                        PopperComponent={(props) => (
                            <Paper {...props} sx={{ mt: 1, boxShadow: 3 }} />
                        )}
                    />

                    {/* Active Filter Display */}
                    {regionsearchvalue && (
                        <Chip
                            label={regionsearchvalue}
                            onDelete={clearSelection}
                            deleteIcon={<ClearIcon />}
                            color="primary"
                            variant="filled"
                            sx={{ maxWidth: 200 }}
                        />
                    )}

                    <Divider orientation="vertical" flexItem />

                    {/* Export Button */}
                    <button className='password-account ml-auto'
                    >
                        Export
                    </button>
                </Box>


        </Box>
    );
};